import { render } from "./ExamDetailModal.vue?vue&type=template&id=c9a777c0&scoped=true"
import script from "./ExamDetailModal.vue?vue&type=script&lang=js"
export * from "./ExamDetailModal.vue?vue&type=script&lang=js"

import "./ExamDetailModal.vue?vue&type=style&index=0&id=c9a777c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9a777c0"]])

export default __exports__